import AppLayout from '@pages/_layout/AppLayout';
import { findForwardRouteForIncidentCommandRoot } from '@pages/_loader/runRouteGuards';
import IncidentCommand from '@pages/IncidentCommand/IncidentCommand';
import { PageNotFound } from '@pages/PageError';
import { SiteMeta } from '@src/types/SiteMeta';
import { RouteObject, useRouteLoaderData } from 'react-router';

function CheckIncidentCommandRootRoutePerms() {
  const siteMeta = useRouteLoaderData('root') as SiteMeta;
  const forwardPath = findForwardRouteForIncidentCommandRoot(siteMeta);
  return forwardPath ? <AppLayout /> : <PageNotFound />;
}

export default [
  {
    path: 'incident-command',
    element: <CheckIncidentCommandRootRoutePerms />,
    children: [{ index: true, element: <IncidentCommand /> }],
  },
] as RouteObject[];
